<template>
  <div style="padding: 20px;background-color: white;height: 100vh">
    <div v-for="item in list" :key="item.id" style="border: 1px solid #BBB;padding: 10px;margin-bottom: 10px">
      <div class="flex justify-between margin-top-xs">
        <span class="label">退款时间</span>
        <span class="value">{{ formatDate(item.createTime, 'YYYY-MM-DD HH:mm') }}</span>
      </div>
      <div class="flex justify-between margin-top-xs">
        <span class="label">退款金额</span>
        <span class="value">￥{{ formatPrice(item.refundFee) }}</span>
      </div>
      <div class="flex justify-between margin-top-xs">
        <span class="label">退款原因</span>
        <span class="value">{{ item.refundDesc }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import {Dialog, Toast} from "vant";
import {listRefund} from "@/api/order";
import Decimal from "decimal.js";
export default {
  name: "refund-detail",
  data(){
    return {
      list: []
    }
  },
  methods:{
    formatPrice(price) {
      if (price != null) {
        return Decimal.div(price, 100).toString()
      }
      return ''
    },
    loadData(){
      Toast.loading({
        mask: true,
        message: '请稍候...'
      })
      listRefund(
          this.$route.params.id
      ).then(res => {
        Toast.clear()
        const data = res.data;
        this.list = data.data
        if (data.code != 0) {
          Dialog.alert({
            title: '加载退款详情失败',
            message: data.msg
          })
        }
      })
    }
  },
  mounted() {
    this.loadData();
  }
}
</script>

<style lang="less" scoped>
.label {
  color: #999;
  width: 120px;
}

.value {
  color: #333;
  text-align: right;
}
</style>
